import { Component } from '@angular/core';

@Component({
  selector: 'app-compass-payment-confirmed',
  standalone: true,
  imports: [],
  templateUrl: './compass-payment-confirmed.component.html',
  styleUrl: './compass-payment-confirmed.component.scss'
})
export class CompassPaymentConfirmedComponent {

}
